import { CheckboxFilterTree } from "@jana-technology/platform-ui";

import { LoadingSpinner } from "components/loaders";
import { useGlobalFiltersContext } from "contexts/filters";
import { HierarchyIdToaster } from "./HierarchyIdToaster";

export const OverviewAssetSelection = () => {
  const {
    updateHierarchyIdsOverview,
    selectedHierarchyIdsOverview,
    setSelectedHierarchyIdsOverview,
    hierarchyCheckboxItemsOverview,
    assetSelectionQueryResult,
  } = useGlobalFiltersContext();

  const hierarchyIdsKeys = Object.keys(selectedHierarchyIdsOverview);
  const submitDisabled = hierarchyIdsKeys.every(
    (key) => selectedHierarchyIdsOverview[key] === false,
  );

  return (
    <HierarchyIdToaster
      selectedHierarchyIdsLength={hierarchyIdsKeys.length}
      submitDisabled={submitDisabled}
    >
      <section>
        <div className="h3 text-sm uppercase text-grey-700">
          Asset Selection
        </div>
        <div className="mt-6">
          <LoadingSpinner
            loading={assetSelectionQueryResult.loading}
            className="h-[79px] w-[280px]"
          >
            {hierarchyIdsKeys.length > 0 && (
              <CheckboxFilterTree
                onCheckedChange={setSelectedHierarchyIdsOverview}
                checkedState={selectedHierarchyIdsOverview}
                submitDisabled={submitDisabled}
                submitButtonOnClick={() => {
                  updateHierarchyIdsOverview(selectedHierarchyIdsOverview);
                }}
                buttonText="Apply Asset Selection"
                fullFilterTree={hierarchyCheckboxItemsOverview}
                filters={hierarchyCheckboxItemsOverview}
                defaultExpandedValues={Object.keys(
                  selectedHierarchyIdsOverview,
                )}
              />
            )}
          </LoadingSpinner>
        </div>
      </section>
    </HierarchyIdToaster>
  );
};

export default OverviewAssetSelection;
